import { DeviceMobileIcon, MapTrifoldIcon } from '@phosphor-icons/react';
import type { ReactNode } from 'react';

import { routes } from './routes';

// Flat primary nav for the top app-bar (<TopNav>). No roles, no sections —
// FieldPro is flat-grower auth; the server scopes resources.
export type NavItem = {
  key: string;
  label: string;
  icon: ReactNode;
  to: string;
};

export const nav: NavItem[] = [
  {
    key: 'devices',
    label: 'Devices',
    icon: <DeviceMobileIcon size={18} />,
    to: routes.devices,
  },
  {
    key: 'map',
    label: 'Map',
    icon: <MapTrifoldIcon size={18} />,
    to: routes.map,
  },
];
